import { render, staticRenderFns } from "./ChannelContainer.vue?vue&type=template&id=9678e9d2&scoped=true"
import script from "./ChannelContainer.vue?vue&type=script&lang=js"
export * from "./ChannelContainer.vue?vue&type=script&lang=js"
import style0 from "./ChannelContainer.vue?vue&type=style&index=0&id=9678e9d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9678e9d2",
  null
  
)

export default component.exports